module.exports = __webpack_public_path__ + "img/other-logo.2a82fa64.png";